import { render } from "./UsersView.vue?vue&type=template&id=3345a88e&ts=true"
import script from "./UsersView.vue?vue&type=script&lang=ts"
export * from "./UsersView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Configuration/Users/UsersView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3345a88e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3345a88e', __exports__)) {
    api.reload('3345a88e', __exports__)
  }
  
  module.hot.accept("./UsersView.vue?vue&type=template&id=3345a88e&ts=true", () => {
    api.rerender('3345a88e', render)
  })

}


export default __exports__